import { render, staticRenderFns } from "./NewsItem.vue?vue&type=template&id=6d6af740&scoped=true&"
import script from "./NewsItem.vue?vue&type=script&lang=ts&"
export * from "./NewsItem.vue?vue&type=script&lang=ts&"
import style0 from "./NewsItem.vue?vue&type=style&index=0&id=6d6af740&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6af740",
  null
  
)

export default component.exports